module.exports = __webpack_public_path__ + "img/warm.be5030ca.webp";